import { gql } from '@efficiently/client-core-graphql-models';

export const UNASSIGN_TAG_FROM_CONTENT = gql(`
	mutation UnassignTagFromContent($tagAssignments: [TagToContentInput!]!) {
		unassignTagFromContent(tagAssignments: $tagAssignments) {
			...TagFields
		}
	}
`);
